<template>
  <!-- The Dentistry: wordmark only (identity manual p11 — never paired with the brandmark). -->
  <img
    v-if="isCiTenant"
    class="logo-login-wordmark my-2"
    src="@/assets/brand/wordmark.svg"
    alt="The Dentistry"
    data-testid="login-wordmark"
  />
  <!-- DentCloud: each page keeps its own logo + caption markup in the slot. -->
  <div v-else class="auth-brand-default">
    <slot></slot>
  </div>
</template>

<script>
import { resolveTenant } from "@/config/tenant";

const TENANT = resolveTenant({ VUE_APP_TENANT: process.env.VUE_APP_TENANT });

export default {
  name: "AuthBrand",
  data() {
    return { isCiTenant: TENANT.isCi };
  },
};
</script>
